import { CubeTextureLoader } from "three";
class SkyboxLoader {
    texture;
    source;
    _isLoaded;
    _isLoading;
    _loadedAt;
    _error;
    _startedLoadingAt;
    loader;
    /**
     * SkyboxLoader object, that loads the skybox and holds the result.
     * @param source the source to the images that consitute the skybox.
     * @param callback callback function to be executed when the image is loaded.
     * @throws If the image fails to load.
     */
    constructor(source, callback) {
        this.loader = new CubeTextureLoader();
        this.source = source;
        this._loadedAt = null;
        this._isLoaded = false;
        this._isLoading = true;
        this._error = null;
        this._startedLoadingAt = Date.now();
        this.load(source, callback);
    }
    /**
     * Load the skybox assets, save the result and set the `loaded` property to `true`.
     * @param source the source to the skybox images.
     * @param callback callback function to be executed when the image is loaded.
     * @throws If an image fails to load.
     */
    load(source, callback) {
        this.loader.load(source, texture => {
            this.texture = texture;
            this._isLoaded = true;
            this._isLoading = false;
            this._loadedAt = Date.now();
            callback();
        }, undefined, error => {
            this._isLoading = false;
            this._error = `Failed to load skybox: ${source}: ${error}`;
            throw new Error(this._error);
        });
    }
    get getSource() {
        return this.source[0];
    }
    get startedLoadingAt() {
        return this._startedLoadingAt;
    }
    get loadedAt() {
        return this._loadedAt;
    }
    get isLoading() {
        return this._isLoading;
    }
    get isLoaded() {
        return this._isLoaded && !!this.texture;
    }
    get error() {
        return this._error;
    }
    get getAsset() {
        return this.texture;
    }
}
export { SkyboxLoader };
